"use client"

import Script from "next/script";
import { useEffect } from "react";

export default function Swan() {

    // the window.swan.pk value needs to be set before script load
    useEffect(() => {
        var swan = (window.swan = window.swan || []);
        swan.pk = 'cm793cck20006le05spfwlrvv';
    });

    return  <Script 
                src={"https://script.getswan.com?pk=cm793cck20006le05spfwlrvv"}
                async
                defer
                strategy="lazyOnload"
            />
}
